import { Link, useNavigate } from "react-router-dom";
import { Fragment, useRef, useState, useContext } from "react";

import AuthContext from "../../store/auth-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import UpdatePasswordModal from "./Modals/UpdatePasswordModal";
import { Alert, AlertTitle } from "@mui/material";

let login_url = process.env.REACT_APP_LOGIN;
const username = localStorage.getItem("username");

const LoginForm = () => {
  const navigate = useNavigate();

  const updating = false;

  const usernameRef = useRef();
  const passwordRef = useRef();

  const authCtx = useContext(AuthContext);

  const [isLoading, setIsLoading] = useState(false);
  const [isUpdatePasswordModalOpen, setIsUpdatePasswordModalOpen] =
    useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();

    const usernameInput = usernameRef.current.value;
    const passwordInput = passwordRef.current.value;

    setIsLoading(true);

    fetch(login_url, {
      method: "POST",
      body: JSON.stringify({
        username: usernameInput,
        password: passwordInput,
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then(async (res) => {
        setIsLoading(false);
        if (res.ok) {
          return res.json();
        } else {
          return res.json().then((data) => {
            let errorMessage = "Authentication Failed";
            if (data && data.error && data.error.message) {
              errorMessage = data.error.message;
            }
            throw new Error(errorMessage);
          });
        }
      })
      .then((data) => {
        authCtx.login(
          data.access,
          data.refresh,
          data.username,
          data.lastLogin,
          data.auth
        );
        navigate("/home/");
        window.location.reload();
      })
      .catch((err) => {
        alert(err.message);
      });
  };

  const handleForgotPasswordClick = () => {
    setIsUpdatePasswordModalOpen(true);
  };

  const handleCloseUpdatePasswordModal = () => {
    setIsUpdatePasswordModalOpen(false);
  };

  const inputClassName =
    "w-full h-9 mt-1 pl-5 shadow-md shadow-black/20 text-black border-solid border border-text-white/30 color-black rounded-lg";
  const sectionClassName = "h-16 w-4/5 m-auto text-xs my-5";

  return (
    <Fragment>
      <div className="w-full h-full grid col-span-10 absolute">
        {updating && (
          <div className="w-5/6 h-max m-auto px-2 flex">
            <Alert
              variant="filled"
              severity="warning"
              className="h-max w-max m-auto"
            >
              <AlertTitle>
                SYSTEM MAINTENANCE: <b>Saturaday 1/11/2024 </b>
              </AlertTitle>
              <p>
                Our system is currently undergoing maintenance throughout the
                day. We apologize for the inconvenience.
              </p>
            </Alert>
          </div>
        )}

        <div className="h-105 w-auto self-center table bg-form-bg-fill/20 rounded-lg shadow shadow-md m-auto sm:w-full md:w-1/2 lg:w-1/2 xl:w-1/3 max-w-screen-xl">
          <Alert
            variant="filled"
            severity="warning"
            className="h-max w-max m-auto"
          >
            <p className="w-max mx-auto">
              Expect web maintence <b>every Thursday between 7-8pm.</b>
            </p>
          </Alert>
          <div className="h- w-full m-auto p-2 mt-2">
            <p className="w-full full h-12 mt-3 text-center font-bold text-3xl">
              Login
            </p>

            {updating ? (
              <span
                className="w-max text-sm mx-auto block"
                title="Click here and follow steps"
              >
                First Time User of STS Connect?
              </span>
            ) : (
              <Link to={"/reset-password"} state={{ newUser: true }}>
                <span
                  className="w-max text-sm cursor-pointer mx-auto block"
                  title="Click here and follow steps"
                >
                  First Time User of STS Connect?
                </span>
              </Link>
            )}

            <form className="h-auto w-full my-auto" onSubmit={submitHandler}>
              {isLoading && <LoadingSpinner />}

              <div className={sectionClassName}>
                <label htmlFor="username" className="w-full">
                  Username
                </label>
                <br />
                <input
                  type="text"
                  className={inputClassName}
                  required
                  placeholder="username"
                  ref={usernameRef}
                />
              </div>
              <div className={sectionClassName}>
                <label htmlFor="password">Password</label>
                <br />
                <input
                  type="password"
                  className={inputClassName}
                  required
                  placeholder="password"
                  ref={passwordRef}
                />
              </div>
              <div className={sectionClassName}>
                <div className="h-full w-3/4 mx-auto my-5">
                  <button
                    disabled={updating ? true : false}
                    type="submit"
                    className= {updating 
                      ? "w-full text-sm h-10 shadow-md shadow-black/20 border-solid border border-text-white/30 rounded-lg "
                      : "w-full text-sm h-10 shadow-md shadow-black/20 border-solid border border-text-white/30 rounded-lg hover:bg-text-white/20"
                    }
                  >
                    Sign In
                  </button>
                </div>
              </div>

              {!updating &&
                <div className="flex w-1/2 m-auto justify-self-center mt-5 h-5">
                  <p className="w-16 h-3 float-left border-b-2 border-solid border-white/30"></p>
                  <div className="w-6 m-auto float-left text-center border-solid border border-text-white/40 rounded-md bg-text-white/20">
                    <p className="text-xs">Or</p>
                  </div>
                  <p className="w-16 h-3 float-left border-b-2 border-solid border-white/30"></p>
                </div> 
              }

              <div className="w-full h-12 my-5 text-center">
                {updating ? ( ''
                ) : (
                  <>
                    <Link to="/login-support" className="w-full text-sm">
                      Login Problems? Contact Support Here!
                    </Link>
                    <br />
                    <div>
                      <Link
                        to="/reset-password"
                        className="w-full italic text-sm cursor-pointer"
                      >
                        Forgot password?
                      </Link>
                    </div>
                  </>
                )}
              </div>

              {updating && (
                <button
                  type="submit"
                  className="w-max text-sm h-10 cursor-pointer"
                >
                  <span className="text-transparent">Sign In</span>
                </button>
              )}
            </form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginForm;
